import { Branch } from './Branch';
export const getBranchConfig = {
    [Branch.CASH_FLOW_DEPOSIT_METHODS]: (client) => ({
        branch: Branch.CASH_FLOW_DEPOSIT_METHODS,
        client
    }),
    [Branch.PUBLISHER_STATUS]: (publisherId) => ({
        branch: Branch.PUBLISHER_STATUS,
        publisherId
    }),
    [Branch.ADMIN_FINANCE_ALERT]: (openedAt) => ({
        branch: Branch.ADMIN_FINANCE_ALERT,
        openedAt
    }),
    [Branch.ADMIN_COMPLAIN_ALERT]: (openedAt) => ({
        branch: Branch.ADMIN_COMPLAIN_ALERT,
        openedAt
    }),
    [Branch.MESSAGES]: (caseId, oldestCreatedAt) => ({
        branch: Branch.MESSAGES,
        caseId,
        oldestCreatedAt
    }),
    [Branch.MESSAGES_V2]: (caseId, options = {}) => ({
        branch: Branch.MESSAGES_V2,
        caseId,
        ...options
    }),
    [Branch.CASH_FLOW_WITHDRAW_PARAMETERS]: (method) => ({
        branch: Branch.CASH_FLOW_WITHDRAW_PARAMETERS,
        method
    })
};
//# sourceMappingURL=BranchConfig.js.map